import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { Messages } from 'config';
import { Details } from 'components';
import { mapQuery } from 'utils/query';
import { Supplier } from 'store/api/supplier/types';
import { useAlert, useNavigate, handleMutation } from 'hooks';
import { useEditMutation, useDetailsQuery } from 'store/api/supplier';

import { Form } from './form';

export const Edit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { showSuccessAlert } = useAlert();
  const [edit, mutation] = useEditMutation();

  const { data, ...props } = useDetailsQuery(id!);

  const onSuccess = useCallback(() => {
    showSuccessAlert(`Supplier ${Messages.UPDATED_SUCCESSFULLY}`);
    navigate(-1);
  }, []);

  handleMutation({ ...mutation, onSuccess });

  return (
    <Details {...mapQuery(props)}>
      {data && <Form<Supplier> onSubmit={edit} initialValues={data} />}
    </Details>
  );
};
